import * as React from "react";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _VideoFileLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return React.createElement("span", { className: classes, ref: ref, ...rest },
        React.createElement("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24" },
            React.createElement("path", { stroke: "currentColor", d: "M13.172 3H9c-1.886 0-2.828 0-3.414.586S5 5.114 5 7v10c0 1.886 0 2.828.586 3.414S7.114 21 9 21h6c1.886 0 2.828 0 3.414-.586S19 18.886 19 17V8.828c0-.408 0-.613-.076-.796s-.22-.329-.51-.618l-3.828-3.828c-.29-.29-.434-.434-.617-.51C13.785 3 13.58 3 13.172 3Z" }),
            React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m13.855 14.08-3.182-1.363A1.2 1.2 0 0 0 9 13.82v2.36a1.2 1.2 0 0 0 1.673 1.103l3.182-1.364c.808-.346.808-1.492 0-1.838" }),
            React.createElement("path", { stroke: "currentColor", d: "M13 3v4c0 .943 0 1.414.293 1.707S14.057 9 15 9h4" })));
}
const VideoFileLight = forwardRef(_VideoFileLight);
export { VideoFileLight };
